import {
  GET_BANKS,
  GET_BANKS_SUCCESS,
  GET_BANKS_FAIL,
  SAVE_BANKS,
  SAVE_BANKS_SUCCES,
  SAVE_BANKS_ERROR,
  DELETE_BANK,
  DELETE_BANK_SUCCESS,
  DELETE_BANK_FAIL,
  EDIT_BANK,
  EDIT_BANK_SUCCESS,
  EDIT_BANK_FAIL,
  INIT_BANK
} from "./actionTypes"

const INIT_STATE = {
  banks: [],
  types: [],
  error: "",
  loading: true,
  loadingSave: false,
  response: null,
  responseDelete: null,
}

const banks = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BANKS:
      return {
        ...state,
        banks: [],
        loading: true,
        response: null,
      }
    case GET_BANKS_SUCCESS:
      return {
        ...state,
        banks: action.payload.data,
        loading: false,
      }

    case GET_BANKS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
      }
    case DELETE_BANK_SUCCESS:
      return {
        ...state,
        response: action.payload.data,
        loading: false,
        responseDelete: action.payload.data,
      }
    case DELETE_BANK:
      return {
        ...state,
        response: null,
        loading: true,
        responseDelete: null,
      }
    case SAVE_BANKS:
      return {
        ...state,
        loading: true,
        loadingSave: true,
        response: null,
      }
    case SAVE_BANKS_SUCCES:
      return {
        ...state,
        loadingSave: false,
        loading: false,
        error: "",
        response: action.payload.data,
      }
    case EDIT_BANK:
      return {
        ...state,
        loadingSave: true,
        error: "",
        response: null,
      }
    case EDIT_BANK_SUCCESS:
      return {
        ...state,
        loadingSave: false,
        loading: false,
        error: "",
        response: action.payload.data,
      }
    case EDIT_BANK_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
        loadingSave: false,
      }
    case DELETE_BANK_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
        loadingSave: false,
      }
    case SAVE_BANKS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
        loadingSave: false,
      }
    case INIT_BANK:
      return {
        ...state,
        error: null,
      }
    default:
      return state
  }
}

export default banks
